import Swal from "sweetalert2";
import * as Cesium from 'cesium';
import { makeStyles } from "@mui/styles";
import { CollectionCategoryEnum } from "Enums";
import StacInterface from "utils/StacInterface";
import FormControl from '@mui/material/FormControl';
import { MenuItem, Select, Menu } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import useViewerStore from '../../store-zustand/viewer';
import withReactContent from "sweetalert2-react-content";
import { getLayerCollectionDetail } from "@/utils/helpers";
import React, { useState, useRef, useEffect } from "react";
import TooltipIconButton from "components/TooltipIconButton";
import { Content, FormItem, Indicators, Footer, Wrapper } from '../ActionModal';
import { getGlobePositionWithTerrain, generateNodeImage, ToolTipDisplay } from '../MapView/MapUtils';
import { Close, DataSaverOffOutlined, CreditCardOutlined, Wallpaper, MoreVert } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 0,
    minWidth: 131,
    position: 'relative'
  }
}));

const projections = [
  { value: 1, label: 'Source', name: 'Source' },
  { value: 2, label: 'WGS84/Pseudo-Mercator', name: 'EPSG:3857' },
  { value: 3, label: 'WGS84', name: 'EPSG:4326' },
  { value: 4, label: 'NAD83/Statistics Canada Lambert', name: 'EPSG:3347' }
];

const resolutions = [
  { value: 1, label: 'Full' },
  { value: 3 / 4, label: '3/4' },
  { value: 1 / 2, label: '1/2' },
  { value: 1 / 4, label: '1/4' },
  { value: 1 / 8, label: '1/8' }
];

const DataExportModal = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const mouseHandler = useRef();
  const rectanglePositions = useRef([]);
  const rectangleAdded = useRef(false);
  const [price, setPrice] = useState();
  const [area, setArea] = useState();
  const [noAssets, setNoAssets] = useState();
  const [exportBtnActive, setExportBtnActive] = useState(false);
  const { mapboxvisibility, setmapboxvisibility } = useViewerStore();
  const [selectedMissionDate, setSelectedMissionDate] = useState(null)
  const selectedMission = useSelector(state => state.asset.selectedMission?.split(':')[1]);
  const selectedCollection = useSelector(state => state.asset.selectedMission ? getLayerCollectionDetail(state.asset.selectedMission)[1] : undefined);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const activeShapePoints = useRef([]);
  const circles = useRef([]);
  const floatingPoint = useRef();
  const [formData, setFormData] = useState({
    mission_name: selectedMission,
    collection_name: selectedCollection?.name,
    resolution: 1,
    projection: 1,
    boundary: []
  });
  
  const handleClickMore = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (props.missionDates === undefined || props.missionDates.length === 0) return;
    
    for (let missionDate in props.missionDates) {
      if (Object.keys(props.missionDates[missionDate])[0].endsWith(selectedMission)) {
        if (selectedCollection.category === CollectionCategoryEnum.streetview) {
          setFormData(prev => ({...prev, mission_name: selectedMission, collection_name: selectedCollection.name, resolution: 1}));
        } else {
          setFormData(prev => ({...prev, mission_name: selectedMission, collection_name: selectedCollection.name}));
        }
        setSelectedMissionDate(new Date(Object.values(props.missionDates[missionDate])[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' }));
        break;
      }
    }
  }, [selectedMission, selectedCollection])

  useEffect(() => {
    if (
      window.exportRectangle === undefined &&
      window.kmlExportPolygon === undefined &&
      window.geojsonExportPolygon === undefined &&
      window.exportPolygon === undefined
    ) return;
    
    var data = {
      boundary_coordinates: formData.boundary,
      mission_name: formData.mission_name,
      collection_name: formData.collection_name,
      resolution: formData.resolution,
      outputCRS: projections[formData.projection - 1].name
    }

    setExportBtnActive(false);
    StacInterface.instance.cropPrice(data).then((response) => {
      setPrice(response.data.price);
      setArea(response.data.area);
      setNoAssets(response.data.no_assets);
      setExportBtnActive(true);
    }).catch((err) => {
      setPrice();
      setArea();
      setExportBtnActive(false);
      withReactContent(Swal).fire({
        title: "Error",
        html: err.response.data?.detail,
      });
    })
  }, [formData])

  const handleChange = (event, name) => {
    if (name == "resolution") setFormData(prev => ({...prev, resolution: event.target.value}));
    if (name == "projection") setFormData(prev => ({...prev, projection: event.target.value}));
  };

  const removeExportRectangle = () => {
    if (mouseHandler.current) {
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }

    window.MAIN_CESIUM_VIEWER.entities.remove(window.exportRectangle);
    delete (window.exportRectangle);
    rectanglePositions.current = [];
    rectangleAdded.current = false;

    document.getElementById("cesium-wrapper").style.cursor = 'auto';
  }

  const removeExportPolygon = () => {
    if (mouseHandler.current) {
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }

    window.MAIN_CESIUM_VIEWER.entities.remove(window.exportPolygon);
    delete (window.exportPolygon);
    activeShapePoints.current = [];
    circles.current.map(c => {
      window.MAIN_CESIUM_VIEWER.entities.remove(c);
    })
    circles.current = [];
    window.MAIN_CESIUM_VIEWER.entities.remove(floatingPoint.current);
    floatingPoint.current = null;
    document.getElementById("cesium-wrapper").style.cursor = 'auto';
  }

  const closeModal = () => {
    removeExportRectangle();
    removeExportPolygon();
    window.MAIN_CESIUM_VIEWER.entities.remove(window.kmlExportPolygon);
    delete (window.kmlExportPolygon)
    window.MAIN_CESIUM_VIEWER.entities.remove(window.geojsonExportPolygon);
    delete (window.geojsonExportPolygon)

    dispatch({ type: 'TOGGLE_EXPORT_MODAL', show: false });

    setmapboxvisibility(0);
  }

  const sendCropRequest = () => {
    var data = {
      boundary_coordinates: formData.boundary,
      mission_name: formData.mission_name,
      collection_name: formData.collection_name,
      resolution: formData.resolution,
      outputCRS: projections[formData.projection - 1].name,
      outputFormat: selectedCollection.category === CollectionCategoryEnum.web_service ? 'png' : selectedCollection.category === CollectionCategoryEnum.streetview ? 'zip' : 'tif',
    }

    StacInterface.instance.crop(data).then(response => {
      if (response?.data?.message) {
        withReactContent(Swal).fire({
          title: "Success",
          html: response.data.message,
        });
      } else {
        var url = response?.data;

        if (url) {
          const link = document.createElement('a');

          link.href = url;
          link.target = "_blank";

          link.click();
          link.remove();
        }
      }
    }).catch((err) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: err.response.data?.detail,
      });
    })
  }

  const drawRectangle = () => {
    removeExportRectangle();
    removeExportPolygon();
    window.MAIN_CESIUM_VIEWER.entities.remove(window.kmlExportPolygon);
    delete (window.kmlExportPolygon)
    window.MAIN_CESIUM_VIEWER.entities.remove(window.geojsonExportPolygon);
    delete (window.geojsonExportPolygon)

    document.getElementById("cesium-wrapper").style.cursor = 'crosshair';

    mouseHandler.current = new Cesium.ScreenSpaceEventHandler(window.MAIN_CESIUM_VIEWER.scene.canvas);

    mouseHandler.current.setInputAction(function (movement) {
      let newPos = getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, movement.endPosition);
      if (rectanglePositions.current[0] && !rectangleAdded.current)
        rectanglePositions.current[1] = newPos;
      if (rectanglePositions.current.length === 2 && !rectangleAdded.current) {
        if (window.exportRectangle) return;
        window.exportRectangle = window.MAIN_CESIUM_VIEWER.entities.add({
          rectangle: {
            coordinates: new Cesium.CallbackProperty(() => {
              if (rectanglePositions.current[0].longitude < rectanglePositions.current[1].longitude) {
                var west = rectanglePositions.current[0].longitude;
                var east = rectanglePositions.current[1].longitude;
              } else {
                var west = rectanglePositions.current[1].longitude;
                var east = rectanglePositions.current[0].longitude;
              }

              if (rectanglePositions.current[0].latitude < rectanglePositions.current[1].latitude) {
                var south = rectanglePositions.current[0].latitude;
                var north = rectanglePositions.current[1].latitude;
              } else {
                var south = rectanglePositions.current[1].latitude;
                var north = rectanglePositions.current[0].latitude;
              }

              return Cesium.Rectangle.fromRadians(west, south, east, north);
            }, false),
            material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
          },
          polyline: {
            positions: new Cesium.CallbackProperty(() => {
              if (rectanglePositions.current[0].longitude < rectanglePositions.current[1].longitude) {
                var west = rectanglePositions.current[0].longitude;
                var east = rectanglePositions.current[1].longitude;
              } else {
                var west = rectanglePositions.current[1].longitude;
                var east = rectanglePositions.current[0].longitude;
              }

              if (rectanglePositions.current[0].latitude < rectanglePositions.current[1].latitude) {
                var south = rectanglePositions.current[0].latitude;
                var north = rectanglePositions.current[1].latitude;
              } else {
                var south = rectanglePositions.current[1].latitude;
                var north = rectanglePositions.current[0].latitude;
              }

              var coords = [west, south, east, south, east, north, west, north, west, south];

              return new Cesium.Cartesian3.fromRadiansArray(coords);
            }, false),
            width: 1.5,
            material: new Cesium.Color.fromCssColorString('#487BF2'),
            clampToGround: true
          }
        });
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    mouseHandler.current.setInputAction(function (click) {
      if (rectanglePositions.current.length === 0) {
        rectanglePositions.current.push(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position));
      } else {
        if (!rectangleAdded.current) {
          rectangleAdded.current = true;
          if (rectanglePositions.current[0].longitude < rectanglePositions.current[1].longitude) {
            var west = rectanglePositions.current[0].longitude;
            var east = rectanglePositions.current[1].longitude;
          } else {
            var west = rectanglePositions.current[1].longitude;
            var east = rectanglePositions.current[0].longitude;
          }

          if (rectanglePositions.current[0].latitude < rectanglePositions.current[1].latitude) {
            var south = rectanglePositions.current[0].latitude;
            var north = rectanglePositions.current[1].latitude;
          } else {
            var south = rectanglePositions.current[1].latitude;
            var north = rectanglePositions.current[0].latitude;
          }

          var polylineCoords = [west, south, east, south, east, north, west, north, west, south];

          window.MAIN_CESIUM_VIEWER.entities.remove(window.exportRectangle);
          window.exportRectangle = window.MAIN_CESIUM_VIEWER.entities.add({
            rectangle: {
              coordinates: Cesium.Rectangle.fromRadians(west, south, east, north),
              material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
            },
            polyline: {
              positions: Cesium.Cartesian3.fromRadiansArray(polylineCoords),
              width: 1.5,
              material: new Cesium.Color.fromCssColorString('#487BF2'),
              clampToGround: true
            }
          });

          var coords = window.exportRectangle.rectangle.coordinates._value;
          var west = coords.west * Cesium.Math.DEGREES_PER_RADIAN;
          var south = coords.south * Cesium.Math.DEGREES_PER_RADIAN;
          var east = coords.east * Cesium.Math.DEGREES_PER_RADIAN;
          var north = coords.north * Cesium.Math.DEGREES_PER_RADIAN;
          setFormData(prev => ({...prev, boundary: [[west, north], [east, north], [east, south], [west, south], [west, north]]}));
        } else {
          window.MAIN_CESIUM_VIEWER.entities.remove(window.exportRectangle);
          delete (window.exportRectangle);
          rectanglePositions.current = [];
          rectangleAdded.current = false;
          rectanglePositions.current.push(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position));
        }
      }

    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    handleCloseMenu();
  }

  const drawPolygon = () => {
    removeExportRectangle();
    removeExportPolygon();
    window.MAIN_CESIUM_VIEWER.entities.remove(window.kmlExportPolygon);
    delete (window.kmlExportPolygon)
    window.MAIN_CESIUM_VIEWER.entities.remove(window.geojsonExportPolygon);
    delete (window.geojsonExportPolygon)

    document.getElementById("cesium-wrapper").style.cursor = 'crosshair';

    mouseHandler.current = new Cesium.ScreenSpaceEventHandler(window.MAIN_CESIUM_VIEWER.scene.canvas);

    mouseHandler.current.setInputAction(function (click) {
      if (activeShapePoints.current.length == 0) {
        activeShapePoints.current.push(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position));
        window.exportPolygon = window.MAIN_CESIUM_VIEWER.entities.add({
          polygon: {
            hierarchy: new Cesium.CallbackProperty(function () {
              return new Cesium.PolygonHierarchy(
                Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray(activeShapePoints.current)
              );
            }, false),
            material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
          },
          polyline: {
            positions: new Cesium.CallbackProperty(function () {
              return Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray(
                [...activeShapePoints.current, activeShapePoints.current[0]]
              )
            }, false),
            width: 1.5,
            material: new Cesium.Color.fromCssColorString('#487BF2'),
            clampToGround: true
          }
        });

        let circleImage = generateNodeImage('#487BF2', true);
        floatingPoint.current = window.MAIN_CESIUM_VIEWER.entities.add({
          position: Cesium.Cartographic.toCartesian(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position)),
          billboard: {
            image: circleImage,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.CENTER,
            width: 15,
            height: 15,
            heightReference: Cesium.HeightReference.NONE
          }
        });
      }
      if (activeShapePoints.current.length >= 2) {
        var geodesic = new Cesium.EllipsoidGeodesic();
        geodesic.setEndPoints(activeShapePoints.current[0], getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position));
        var lengthInMeters = geodesic.surfaceDistance;
        if (lengthInMeters <= 0.25) {
          activeShapePoints.current.pop();
          ToolTipDisplay(2);
          mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
          mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
          document.getElementById("cesium-wrapper").style.cursor = 'auto';

          var boundary = [];
          activeShapePoints.current.map(p => {
            boundary.push([
              p.longitude * Cesium.Math.DEGREES_PER_RADIAN,
              p.latitude * Cesium.Math.DEGREES_PER_RADIAN
            ])
          })
          boundary.push([
            activeShapePoints.current[0].longitude * Cesium.Math.DEGREES_PER_RADIAN,
            activeShapePoints.current[0].latitude * Cesium.Math.DEGREES_PER_RADIAN
          ])
          setFormData(prev => ({...prev, boundary: boundary}));
        }
      }
      activeShapePoints.current.push(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position));

      let circleImage = generateNodeImage('#487BF2', true);
      var point = window.MAIN_CESIUM_VIEWER.entities.add({
        position: Cesium.Cartographic.toCartesian(getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, click.position)),
        billboard: {
          image: circleImage,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          width: 15,
          height: 15,
          heightReference: Cesium.HeightReference.NONE
        }
      });
      circles.current.push(point);
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    mouseHandler.current.setInputAction(function (movement) {
      if (window.exportPolygon) {
        ToolTipDisplay(2);
        var newPosition = getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, movement.endPosition);
        if (Cesium.defined(newPosition)) {
          floatingPoint.current.position.setValue(
            Cesium.Cartographic.toCartesian(newPosition)
          );
          activeShapePoints.current.pop();
          activeShapePoints.current.push(newPosition);

          var geodesic = new Cesium.EllipsoidGeodesic();
          geodesic.setEndPoints(activeShapePoints.current[0], newPosition);
          var lengthInMeters = geodesic.surfaceDistance;
          if (lengthInMeters <= 0.25) {
            let pixel_position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.MAIN_CESIUM_VIEWER.scene, Cesium.Cartographic.toCartesian(newPosition));
            ToolTipDisplay(1, pixel_position, 'Click to close Polygon');
          }
        }
      } else {
        var newPosition = getGlobePositionWithTerrain(window.MAIN_CESIUM_VIEWER, movement.endPosition);
        let pixel_position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.MAIN_CESIUM_VIEWER.scene, Cesium.Cartographic.toCartesian(newPosition));
        ToolTipDisplay(1, pixel_position, 'Click for starting point');
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handleCloseMenu();
  }

  const handleKML = () => {
    const input = document.getElementById('kml-input');
    input.value = '';
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.addEventListener('load', (loadEvent) => {
        const data = new DOMParser().parseFromString(loadEvent.target.result, 'text/xml');
        const coordinatesNode =
          data.querySelector('Polygon coordinates') ||
          data.querySelector('LinearRing coordinates') ||
          data.querySelector('coordinates');

        if (!coordinatesNode) {
          withReactContent(Swal).fire({
            title: "Error",
            html: "No coordinates found in the KML file.",
          });
          return;
        }

        const boundary = [];
        const cartoCoords = [];
        coordinatesNode.textContent.trim().split(/\s+/).forEach((tuple) => {
          if (!tuple) return;
          const parts = tuple.split(',');
          const lon = Number(parts[0]);
          const lat = Number(parts[1]);
          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return;
          boundary.push([lon, lat]);
          cartoCoords.push(Cesium.Cartographic.fromDegrees(lon, lat));
        });

        if (cartoCoords.length < 3) {
          withReactContent(Swal).fire({
            title: "Error",
            html: "The KML file does not contain a valid polygon (need at least 3 coordinates).",
          });
          return;
        }

        removeExportRectangle();
        removeExportPolygon();
        window.MAIN_CESIUM_VIEWER.entities.remove(window.kmlExportPolygon);
        delete (window.kmlExportPolygon)
        window.MAIN_CESIUM_VIEWER.entities.remove(window.geojsonExportPolygon);
        delete (window.geojsonExportPolygon)

        window.kmlExportPolygon = window.MAIN_CESIUM_VIEWER.entities.add({
          polygon: {
            hierarchy: Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray(cartoCoords),
            material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
            perPositionHeight: false
          },
          polyline: {
            positions: Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray([...cartoCoords, cartoCoords[0]]),
            width: 1.5,
            material: new Cesium.Color.fromCssColorString('#487BF2'),
            clampToGround: true
          }
        });
        window.MAIN_CESIUM_VIEWER.flyTo(window.kmlExportPolygon)

        setFormData(prev => ({...prev, boundary: boundary}));
      });
      reader.readAsText(file);
    };
    input.click();
    handleCloseMenu();
  }

  const handleGeoJson = () => {
    document.getElementById('geojson-input').addEventListener('change', event => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.addEventListener('load', (event) => {
        var geojson = JSON.parse(event.target.result);
        var coords = geojson.features[0].geometry.coordinates[0];
        var cartoCoords = [];
        coords.map(c => {
          cartoCoords.push(new Cesium.Cartographic.fromDegrees(Number(c[0]), Number(c[1])))
        })

        removeExportRectangle();
        removeExportPolygon();
        window.MAIN_CESIUM_VIEWER.entities.remove(window.kmlExportPolygon);
        delete (window.kmlExportPolygon)
        window.MAIN_CESIUM_VIEWER.entities.remove(window.geojsonExportPolygon);
        delete (window.geojsonExportPolygon)

        window.geojsonExportPolygon = window.MAIN_CESIUM_VIEWER.entities.add({
          polygon: {
            hierarchy: Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray(cartoCoords),
            material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
            perPositionHeight: false
          },
          polyline: {
            positions: Cesium.Ellipsoid.WGS84.cartographicArrayToCartesianArray([...cartoCoords, cartoCoords[0]]),
            width: 1.5,
            material: new Cesium.Color.fromCssColorString('#487BF2'),
            clampToGround: true
          }
        });
        window.MAIN_CESIUM_VIEWER.flyTo(window.geojsonExportPolygon)

        console.log(`coords ${coords}`)
        setFormData(prev => ({...prev, boundary: coords}));
      })
      reader.readAsText(file);
    })
    document.getElementById("geojson-input").click();
    handleCloseMenu();
  }

  useEffect(() => {
    setmapboxvisibility(1);

    if (mouseHandler.current) {
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      mouseHandler.current.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }
  }, [])

  return (
    <Wrapper>
      <TooltipIconButton title="Close" ariaLabel="close" placement="bottom" onClick={closeModal} size={44} position="true" top={10} right={10} zIndex={10}>
        <Close />
      </TooltipIconButton>
      <Content>
        <TooltipIconButton title="More" ariaLabel="draw-area" placement="top" size={60} position="true" top={-29} right={30} bluebg="true" onClick={handleClickMore} >
          <MoreVert />
        </TooltipIconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleCloseMenu}
          MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
          <MenuItem onClick={handleKML}>Import KML<input type="file" id="kml-input" style={{ 'display': 'none' }} /></MenuItem>
          <MenuItem onClick={handleGeoJson}>Import GeoJSON<input type="file" id="geojson-input" style={{ 'display': 'none' }} /></MenuItem>
          <MenuItem onClick={drawRectangle}>Draw Rectangle</MenuItem>
          <MenuItem onClick={drawPolygon}>Draw Polygon</MenuItem>
        </Menu>
        <h3>Export Crop</h3>
        <FormItem>
          <p>Collection</p>
          <FormControl variant="filled" className={classes.formControl}>
            <div className="MuiSelect-root">
              {selectedCollection.name}
            </div>
          </FormControl>
        </FormItem>
        <FormItem>
          <p>Mission Date</p>
          <FormControl variant="filled" className={classes.formControl}>
            <div className="MuiSelect-root">
              {selectedMissionDate}
            </div>
          </FormControl>
        </FormItem>
        <FormItem>
          <p>Projection</p>
          <FormControl variant="filled" className={classes.formControl}>
            <Select value={formData.projection} name="projection" onChange={(e) => handleChange(e, 'projection')}>
              {projections.map((item, index) => (<MenuItem value={item.value} key={index}>{item.label}</MenuItem>))}
            </Select>
          </FormControl>
        </FormItem>
        <FormItem>
          <p>Resolution</p>
          <FormControl variant="filled" className={classes.formControl}>
            <Select disabled={selectedCollection.category === CollectionCategoryEnum.streetview} value={formData.resolution} name="resolution" onChange={(e) => handleChange(e, 'resolution')}>
              {resolutions.map((item, index) => (<MenuItem value={item.value} key={index}>{item.label}</MenuItem>))}
            </Select>
          </FormControl>
        </FormItem>
      </Content>
      <Indicators style={{ background: '#2F2F2F' }}>
        <div className="half-section border-right">
          <DataSaverOffOutlined sx={{ color: 'rgb(227 171 84)', fontSize: '24px' }} />
          <div>
            {
              selectedCollection.category !== CollectionCategoryEnum.streetview ? 
              (area ? (area >= 0.05 ? (<p>{area.toFixed(2)}<span>k㎡</span></p>) : (<p>{(area * 1000000).toFixed(0)}<span>㎡</span></p>)) : (<p>-<span>k㎡</span></p>)) : 
              (noAssets ? <p>{noAssets}<span>assets</span></p> : "")
            }
          </div>
        </div>
        <div className="half-section">
          <CreditCardOutlined sx={{ color: 'rgb(22 198 125)', fontSize: '24px' }}/>
          <p><span>$</span> {price ? (price / 100).toFixed(2) : "-"}</p>
        </div>
      </Indicators>
      {exportBtnActive ?
        <button onClick={sendCropRequest} style={{ width: "100%", padding: 0, background: '#2F2F2F' }}>
          <Footer>
            <Wallpaper style={{ color: "white", width: 20, height: 20 }} />
            <span>Export Cropped Area</span>
          </Footer>
        </button> :
        <button style={{ width: "100%", padding: 0, background: '#2F2F2F' }}>
          <Footer>
            <Wallpaper style={{ color: "grey", width: 20, height: 20 }} />
            <span style={{ color: "grey" }}>Export Cropped Area</span>
          </Footer>
        </button>
      }
    </Wrapper>
  );
};

export default DataExportModal;